'use es6';

import { getMessages as getter } from './getters';

// TODO: Deprecate
export const getMessages = getter;